import styled from 'styled-components'

export const Container = styled.div`
  background-color: #FFF;
  box-shadow: 0px 5px 20px -5px #00A98833;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-height: 144px;
  max-width: 196px;
  min-height: 144px;
  min-width: 196px;
  padding: 16px;

  & > figure img {
    max-height: 24px;
    min-height: 24px;
    max-width: 24px;
    min-width: 24px;
  }

  h4 {
    color: #00A988;
    font-size: 0.875rem;
    font-weight: 600;
    font-size: 14px;
    line-height: 140%;
  }

  p {
    color: #084F43;
    font-size: 0.875rem;
    font-weight: 400;
    line-height: 140%;
    letter-spacing: -0.6px;

    @media (max-width: 568px) {
     font-size: 0.75rem;
    }
  }
`
